
/**
 * Description: This is a stimulus controller mixin.
 *              When used, it will add to the controller's targets a method with the format of <target>TargetWithId().
 *              This will allow to search for targets with specific id.
 * How to use it:
 *            In order to define a target id, we need to declare an attribute like
 *            'data-<controller identifier>-<target name>-id' on the corresponding target.
 *            Example
 *                <template
                    data-contacts-person--form-target="template"
                    data-contacts-person--form-template-id="email">

              Use in the connect method the useTargetWithIds method to set the mixin;
              Example
              connect(){
                useTargetsWithIds(this, ["template"])
              }

              After that, the method for getting a target with a specific id will be available.
              Example
              printEmailTemplate(event){
                console.log(this.templateTargetWithId("email"))
              }

 * @param {stimulus controller} c - This is where the mixing will be added.
 * @param {[String]} targetNamesSupported  - Target names that will have the <target>TargetWithId() method
 */
export const useTargetsWithIds = (c, targetNamesSupported) => {
  const targetHasId = (targetDom, targetName, id) => {
    return targetDom.getAttribute(`data-${c.identifier}-${targetName}-id`) === id
  }

  targetNamesSupported.forEach((targetName) => {
    c[`${targetName}TargetWithId`] = (id) => {
      const targetInstances = c[`${targetName}Targets`]
      return targetInstances.find((targetDom) => {
        return targetHasId(targetDom, targetName, id)
      })
    }
  })
}

export default useTargetsWithIds
